/* CHITA homepage motion (GSAP + ScrollTrigger). Content stays visible if GSAP fails to load. */
(function () {
  var root = document.documentElement;
  function release() { root.classList.remove('ch-anim-wait'); }
  if (!window.gsap || !window.ScrollTrigger) return release();
  /* In the theme editor sections re-render on every change; keep content static there. */
  if (window.Shopify && Shopify.designMode) return release();
  ScrollTrigger.config({ ignoreMobileResize: true });
  gsap.registerPlugin(ScrollTrigger);
  var mm = gsap.matchMedia();
  var ease = 'power3.out';
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  mm.add({ motion: '(prefers-reduced-motion: no-preference)', desktop: '(min-width: 750px)' }, function (ctx) {
    if (!ctx.conditions.motion) return release();
    var desk = ctx.conditions.desktop, cleanups = [];
    release();
    /* 10/28 review #1/#3/#4/#11: no entrance animations here any more. The header and hero text are part of the first paint; the hero fades in
       as one layer from CSS (chita-home.css), Season's Edit has its own entrance (section script), every other section just displays.
       The hero photo only moves during a slide switch (CSS, chita-hero.liquid) - the continuous Ken Burns zoom is gone.
       v2 (10/28, client "按设计稿"): the scroll parallax on the hero / Season's Edit / Invited / Story backgrounds is removed - Figma has no such
       motion; every background sits at its Figma crop. Entrance, tab and carousel animations below are unchanged. */

    /* Tab / carousel transitions: re-animate the newly visible content after a click */
    var onClick = function (e) {
      var b = e.target.closest('.ch-insp__head .ch-pill button'); /* Season's Edit + Live With tab swaps: shared choreography in chita-tabfx.js (QA7 #1/#2) */
      if (b && !b.classList.contains('is-active')) { /* capture phase: runs before the section's own handler, so an already-active tab does not replay */
        requestAnimationFrame(function () {
          var sec = b.closest('section');
          var items = sec.querySelectorAll('.ch-insp__list.is-active .ch-insp__card');
          /* 10/27 review #1: switch = 0.8s soft fade, <=8px rise, <=0.05s stagger */
          gsap.fromTo(items, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', stagger: 0.04, overwrite: 'auto', clearProps: 'transform' });
          /* scene: the whole new scene (after + before + handle) fades in over the previous one, which the section keeps visible underneath (.is-prev) */
          gsap.fromTo(sec.querySelectorAll('.ch-insp__scene.is-active'), { opacity: 0 }, { opacity: 1, duration: 0.8, ease: 'power2.out', overwrite: 'auto' });
        });
      }
    };
    document.addEventListener('click', onClick, true);
    cleanups.push(function () { document.removeEventListener('click', onClick, true); });

    /* Season's Edit / Live With card hover lift + image zoom removed (10/27 review #2); Season's hover slideshow lives in chita-season-edit.liquid */

    return function () { cleanups.forEach(function (f) { f(); }); };
  });
})();
